var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconScan = function SvgIconScan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1380_5968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 0.5C17.7239 0.5 17.5 0.723858 17.5 1C17.5 1.27614 17.7239 1.5 18 1.5H21C21.8284 1.5 22.5 2.17157 22.5 3V6C22.5 6.27614 22.7239 6.5 23 6.5C23.2761 6.5 23.5 6.27614 23.5 6V3C23.5 1.61929 22.3807 0.5 21 0.5H18Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 23.5C6.27614 23.5 6.5 23.2761 6.5 23C6.5 22.7239 6.27614 22.5 6 22.5H3C2.17157 22.5 1.5 21.8284 1.5 21L1.5 18C1.5 17.7239 1.27614 17.5 1 17.5C0.723858 17.5 0.5 17.7239 0.5 18V21C0.5 22.3807 1.61929 23.5 3 23.5H6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1C6.5 0.723858 6.27614 0.5 6 0.5H3C1.61929 0.5 0.5 1.61929 0.5 3V6C0.5 6.27614 0.723857 6.5 1 6.5C1.27614 6.5 1.5 6.27614 1.5 6V3C1.5 2.17157 2.17157 1.5 3 1.5H6C6.27614 1.5 6.5 1.27614 6.5 1Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 23.5C17.7239 23.5 17.5 23.2761 17.5 23C17.5 22.7239 17.7239 22.5 18 22.5H21C21.8284 22.5 22.5 21.8284 22.5 21V18C22.5 17.7239 22.7239 17.5 23 17.5C23.2761 17.5 23.5 17.7239 23.5 18V21C23.5 22.3807 22.3807 23.5 21 23.5H18Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5.5C4.77614 5.5 5 5.72386 5 6L5 18C5 18.2761 4.77614 18.5 4.5 18.5C4.22386 18.5 4 18.2761 4 18L4 6C4 5.72386 4.22386 5.5 4.5 5.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6C6.5 5.72386 6.27614 5.5 6 5.5C5.72386 5.5 5.5 5.72386 5.5 6L5.5 18C5.5 18.2761 5.72386 18.5 6 18.5C6.27614 18.5 6.5 18.2761 6.5 18L6.5 6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 5.5C9.27614 5.5 9.5 5.72386 9.5 6L9.5 18C9.5 18.2761 9.27614 18.5 9 18.5C8.72386 18.5 8.5 18.2761 8.5 18L8.5 6C8.5 5.72386 8.72386 5.5 9 5.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 6C11.5 5.72386 11.2761 5.5 11 5.5C10.7239 5.5 10.5 5.72386 10.5 6L10.5 18C10.5 18.2761 10.7239 18.5 11 18.5C11.2761 18.5 11.5 18.2761 11.5 18L11.5 6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5C13.2761 5.5 13.5 5.72386 13.5 6L13.5 18C13.5 18.2761 13.2761 18.5 13 18.5C12.7239 18.5 12.5 18.2761 12.5 18L12.5 6C12.5 5.72386 12.7239 5.5 13 5.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 6C17.5 5.72386 17.2761 5.5 17 5.5C16.7239 5.5 16.5 5.72386 16.5 6L16.5 18C16.5 18.2761 16.7239 18.5 17 18.5C17.2761 18.5 17.5 18.2761 17.5 18V6Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 5.5C20.2761 5.5 20.5 5.72386 20.5 6V18C20.5 18.2761 20.2761 18.5 20 18.5C19.7239 18.5 19.5 18.2761 19.5 18V6C19.5 5.72386 19.7239 5.5 20 5.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6C19 5.72386 18.7761 5.5 18.5 5.5C18.2239 5.5 18 5.72386 18 6V18C18 18.2761 18.2239 18.5 18.5 18.5C18.7761 18.5 19 18.2761 19 18V6Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1380_5968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "current"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconScan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-scan.9a85c1ba.svg";
export { ForwardRef as ReactComponent };